// extracted by extract-css-chunks-webpack-plugin
module.exports = {"toc-wide-variant":"_1fEwS2","bottom":"_3gaK19","hideDesktop":"_26o4_9","hideNotDesktop":"_3rUEgV","stickyBottomBanner":"mK7XyA"};